
import Vue from 'vue'
import store from '../store';


export default Vue.extend({
  name: 'CartMenu',

  props: {
  },

  data() {
    return {
      cartDialog: false as boolean
    }
  },
  methods: {
    emptyCart(): void {
      this.cartDialog = false;
      store.commit("SET_CART", []);
    },
    removeFromCart(id: number): void {
      const result = store.state.cart?.filter(cartItem => cartItem.Id !== id);
      if (result.length === 0) {
        this.cartDialog = false;
      }
      store.commit("SET_CART", result);
    }
  },
})
